import React, { useState } from 'react'
import Modal, { ModalBody, ModalFooter, ModalHeader } from 'core-system/Modal'
import Text from 'core-system/Text'
import TextField from 'core-system/TextField'
import { useDispatch } from 'react-redux'
import SegmentService from 'redux/config/services/SegmentService'
import styled from 'styled-components'
import SecondaryButton from 'core-system/Button/SecondaryButton'
import PrimaryButton from 'core-system/Button/PrimaryButton'
import { tagsActions } from 'redux/tags/tagsSlice'

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
`

interface TagsCreateModalProps {
  open: boolean
  closeModal: () => void
}

const TagsCreateModal = ({ open, closeModal }: TagsCreateModalProps) => {
  const dispatch = useDispatch()
  const [tagName, setTagName] = useState('')

  const handleCreate = () => {
    if (!tagName.trim()) return
    dispatch(tagsActions.createTag({ name: tagName.trim() }))
    SegmentService.track('addTag-modal-action', { action: 'create' })
    setTagName('')
    closeModal()
  }

  const handleClose = () => {
    setTagName('')
    closeModal()
  }

  return (
    <Modal open={open} onClose={handleClose} maxWidth='sm'>
      <ModalHeader title='Create New Tag' onClose={handleClose} />
      <ModalBody>
        <Text variant='body1' marginBottom='1rem'>
          Tags help you organize and filter commuters. You can assign multiple
          tags to a commuter.
        </Text>
        <TextField
          label='Tag Name'
          value={tagName}
          onChange={(e) => setTagName(e.target.value)}
          fullWidth
          autoFocus
        />
      </ModalBody>
      <ModalFooter>
        <ButtonContainer>
          <SecondaryButton onClick={handleClose} style={{ marginRight: '1rem' }}>
            Cancel
          </SecondaryButton>
          <PrimaryButton onClick={handleCreate} disabled={!tagName.trim()}>
            Create Tag
          </PrimaryButton>
        </ButtonContainer>
      </ModalFooter>
    </Modal>
  )
}

export default React.memo(TagsCreateModal)
